export function selectAnswer(question, answer, answerLetter) {
  return {
    type: 'SELECT_ANSWER',
    payload: {
      question: question,
      answer: answer,
      answerLetter: answerLetter,
    },
  }
}



// WEBPACK FOOTER //
// ./js/components/actions/PillActions.js